import React, { Component } from "react";
import { connect } from "react-redux";

class MyStepper extends Component {
  static defaultProps = {
    activeColor: "#0099cc",
    inactiveColor: "#D1CECE",
    numberOfSteps: 2,
    selected: 0
  };

  render() {
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const steps = [...Array(this.props.numberOfSteps).keys()].map((s, idx) => (
      <div
        className="col mx-1 align-self-center"
        style={{
          width: 30,
          height: 2,
          backgroundColor:
            this.props.selected % this.props.numberOfSteps == idx
              ? themeColor
              : this.props.inactiveColor
        }}
      ></div>
    ));
    return (
      <>
        <div
          className="row stepperWidth"
          style={{
            position: "fixed",
            top: 53,
            height: 5,
            backgroundColor: "white",
            marginRight: "auto",
            marginLeft: "auto"
          }}
        >
          {steps}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    themeColor: state.store.store.settings.dark
  };
};

export default connect(mapStateToProps)(MyStepper);
